export default "__VITE_ASSET___nFf86pS__"